import {
    Component, Input, OnInit
} from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Verification } from 'src/app/interfaces/Verification';
import { DesktopService } from 'src/app/services/desktop.service';
import { MobileService } from 'src/app/services/mobile.service';

@Component({
    selector: 'app-verification-modal',
    templateUrl: './verification-modal.page.html',
    styleUrls: ['./verification-modal.page.scss']
})
export class VerificationModalPageComponent {
    @Input() data: Verification = {
    	nextStep: '',
    	title: '',
    	content: '',
    	icon: ''
    };

    constructor(private navController: NavController, private modalCtr: ModalController, private readonly desktopService: DesktopService, private mobileService: MobileService) { }

    redirectToMessages() {
    	this.close();

    	if (this.desktopService.isDesktop()) {
    		this.mobileService.powerOn();
    		this.navController.navigateBack([{ outlets: { mobile: this.data.nextStep } }]);
    	} else {
    		this.navController.navigateBack([{ outlets: { primary: this.data.nextStep } }]);
    	}
    }

    async close() {
    	return this.modalCtr.dismiss();
    }
}
